<template>
  <div
    role="status"
    class="card-spinner absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2"
  >
    <YSpinner />
    <span class="sr-only">Loading...</span>
  </div>
</template>
<script setup lang="ts">
import { YSpinner } from '@yakimachief/ych-ts-component-library'
</script>
<style scoped lang="scss">
.card-spinner {
  z-index: 100;
  opacity: 75%;
}
</style>
